import { z } from "zod";

import { OrderDirection } from "@/constants/orderDirection";

import { ColumnIds } from "./-constants";

export const SearchSchema = z.object({
  freeText: z.string().optional(),
  showDisabled: z.boolean().default(false),
  sortColumn: z
    .enum([ColumnIds.name, ColumnIds.displayOrder, ColumnIds.code])
    .optional(),
  sortOrder: z.nativeEnum(OrderDirection).optional(),
});
